import { apiClient } from "@config/apiClient";
import { API_URL } from "@config/constants";
import { IAttribute } from "@interfaces/attribute.interface";

class AttributeService {
  private URL = `${API_URL}/attributes`;

  async getAttributes(): Promise<IAttribute[]> {
    return apiClient.get(`${this.URL}/attributes/`);
  }
}

const attributeService = new AttributeService();
export default attributeService;
